import {ApiError} from "@app/core/shared/domain/api.error";

/**
 * An error related to authorization failures.
 * Implements the standard Error interface and allows for additional API error details to be attached.
 * This class helps in distinguishing authorization errors from other types of errors in the application.
 */
export class AuthorizationError implements Error {

    name: string;
    message: string;
    stack: string | undefined;

    constructor(error: any | null, message = "", public apiError?: ApiError) {
        this.name = "AuthorizationError";
        this.message = message;
    }
}
